import request from '../../untils/request';

export function selectList(data) {
	return request({
		url: '/blackList/selectList',
		method: 'get',
		params: data,
	});
}

export function removeBlacklist(data) {
	return request({
		url: '/blackList/delete',
		method: 'get',
		params: data,
	});
}
